



















import path from 'path';

// A lightweight fuzzy-search module
import Fuse from 'fuse.js';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { appModule } from '@/store/modules/ModuleApp';
import { permissionModule } from '@/store/modules/ModulePermission';
import i18n from '@/lang';
@Component({
	name: 'HeaderSearch'
})
/** header search */
export default class HeaderSearch extends Vue {
	private search: any = '';
	private show: any = false;
	private options: RouteConfig[] = [];
	private searchPool: RouteConfig[] = [];
	private fuse?: Fuse<RouteConfig>;

	/** store中引入的属性 .的是引入文件里的方法 */
	private get routes(): any {
		return permissionModule.routes;
	}

	/** store中引入的属性 .的是引入文件里的方法 */
	private get lang(): any {
		return appModule.language;
	}

	/** 监听 数据发生改变时的 */
	@Watch('lang')
	private onLangChange(): any {
		this.searchPool = this.generateRoutes(this.routes);
	}

	/** 监听 数据发生改变时的 */
	@Watch('routes')
	private onRoutesChange(): any {
		this.searchPool = this.generateRoutes(this.routes);
	}

	/** 监听 定义的函数方法 */
	@Watch('searchPool')
	private onSearchPoolChange(value: RouteConfig[]): any {
		this.initFuse(value);
	}

	/** 根据是否有value值 来给元素绑定或者删除点击事件 */
	@Watch('show')
	private onShowChange(value: boolean): any {
		if (value) {
			document.body.addEventListener('click', this.close.bind(this));
		} else {
			document.body.removeEventListener('click', this.close.bind(this));
		}
	}

	/** 查找路由 */
	public mounted(): any {
		this.searchPool = this.generateRoutes(this.routes);
	}

	/** 点击事件 判断按钮是否显示 */
	private click(): any {
		this.show = !this.show;
		if (this.show) {
			if (this.$refs.headerSearchSelect) {
				const searchSelect: any = this.$refs.headerSearchSelect;

				searchSelect.focus();
			}
		}
	}

	/** 判断是否有值的时候 失焦关闭 */
	private close(): any {
		if (this.$refs.headerSearchSelect) {
			const selector: any = this.$refs.headerSearchSelect;

			selector.blur();
		}

		this.options = [];
		this.show = false;
	}

	/** 路由跳转 */
	private change(route: RouteConfig): any {
		this.$router.push(route.path)['catch']((err: any): any => {
			console.warn(err);
		});
		this.search = '';
		this.options = [];
		this.$nextTick(() => {
			this.show = false;
		});
	}

	/** 根据插件完成功能 */
	private initFuse(list: RouteConfig[]): any {
		this.fuse = new Fuse(list, {
			shouldSort: true,
			threshold: 0.4,
			location: 0,
			distance: 100,
			minMatchCharLength: 1,
			keys: [
				{
					name: 'title',
					weight: 0.7
				},
				{
					name: 'path',
					weight: 0.3
				}
			]
		});
	}

	// Filter out the routes that can be displayed in the sidebar
	// And generate the internationalized title

	/** 路由组件 */
	private generateRoutes(routes: RouteConfig[], basePath: any = '/', prefixTitle: string[] = []): any {
		let res: RouteConfig[] = [];

		for (const router of routes) {
			// skip hidden router
			if (router.meta && router.meta.hidden) {
				continue;
			}

			const data: RouteConfig = {
				path: path.resolve(basePath, router.path),
				meta: {
					title: [...prefixTitle]
				}
			};

			if (router.meta && router.meta.title) {
				// generate internationalized title
				const i18ntitle: any = i18n.t(`route.${router.meta.title}`).toString();

				data.meta.title = [...data.meta.title, i18ntitle];
				if (router.redirect !== 'noRedirect') {
					// only push the routes with title
					// special case: need to exclude parent router without redirect
					res.push(data);
				}
			}

			// recursive child routes
			if (router.children) {
				const tempRoutes: any = this.generateRoutes(router.children, data.path, data.meta.title);

				if (tempRoutes.length >= 1) {
					res = [...res, ...tempRoutes];
				}
			}
		}

		return res;
	}

	/** 调用方法 遍历数组 */
	private querySearch(query: string): any {
		if (query !== '') {
			if (this.fuse) {
				this.options = this.fuse.search(query).map((result: any): any => result.item);
			}
		} else {
			this.options = [];
		}
	}
}
